import api from './api';

export const ordenesService = {
    // Obtener todas las órdenes
    getAll: async (params = {}) => {
        const { skip = 0, limit = 100, estado, activo_id, search } = params;
        let url = `/ordenes-trabajo/?skip=${skip}&limit=${limit}`;

        if (estado) url += `&estado=${estado}`;
        if (activo_id) url += `&activo_id=${activo_id}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;

        const response = await api.get(url);
        return response.data;
    },

    // Obtener datos del Kanban
    getKanban: async () => {
        const response = await api.get('/ordenes-trabajo/kanban');
        return response.data;
    },

    // Obtener orden por ID
    getById: async (id) => {
        const response = await api.get(`/ordenes-trabajo/${id}`);
        return response.data;
    },

    // Crear orden
    create: async (ordenData) => {
        const response = await api.post('/ordenes-trabajo/', ordenData);
        return response.data;
    },

    // Actualizar orden
    update: async (id, ordenData) => {
        const response = await api.put(`/ordenes-trabajo/${id}`, ordenData);
        return response.data;
    },

    // Cambiar estado
    cambiarEstado: async (id, nuevoEstado) => {
        const response = await api.post(`/ordenes-trabajo/${id}/estado`, null, {
            params: { nuevo_estado: nuevoEstado }
        });
        return response.data;
    },

    // Eliminar orden
    delete: async (id) => {
        const response = await api.delete(`/ordenes-trabajo/${id}`);
        return response.data;
    }
};
